module.exports = __webpack_public_path__ + "static/img/3-02.4bd2e1f.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/3-02.png
// module id = 229
// module chunks = 0